import React from 'react';
import { Users } from 'lucide-react';
import { AudioEffect, AudioEffectControlProps } from './AudioEffect';
import { AudioSourceRegistry } from '../../../../dataTypes/liveStreamManagment/audioPipeline/AudioSourceRegistry';
import { LevelSlider } from '../LevelSlider';

export interface ChorusConfig {
  /** Vitesse du vibrato, en Hz. */
  rateHz: number;
  /** Amplitude de la modulation, en ms. */
  depthMs: number;
  /** Proportion de signal chorusé mélangé au sec, 0-100%. */
  mix: number;
}

class ChorusEffectImpl extends AudioEffect<ChorusConfig> {
  readonly id = 'chorus';
  readonly label = 'Chorus';
  readonly icon = Users;
  readonly description = 'Double voix — deux voix légèrement désaccordées, effet chœur';
  readonly defaultConfig: ChorusConfig = { rateHz: 1.1, depthMs: 4, mix: 40 };

  apply(registry: AudioSourceRegistry, regId: string, enabled: boolean, config: ChorusConfig): void {
    registry.setChorus(regId, enabled, config.rateHz, config.depthMs, config.mix / 100);
  }

  renderControls({ config, onChange }: AudioEffectControlProps<ChorusConfig>) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <LevelSlider
          label="Vitesse" value={config.rateHz}
          min={0.1} max={5} defaultValue={1.1} roundTo={0.1}
          format={v => `${v.toFixed(1)} Hz`}
          onChange={rateHz => onChange({ ...config, rateHz })}
        />
        <LevelSlider
          label="Profondeur" value={config.depthMs}
          min={0} max={10} defaultValue={4} roundTo={0.5}
          format={v => `${v} ms`}
          onChange={depthMs => onChange({ ...config, depthMs })}
        />
        <LevelSlider
          label="Mix" value={config.mix}
          min={0} max={100} defaultValue={40}
          format={v => `${v}%`}
          onChange={mix => onChange({ ...config, mix })}
        />
      </div>
    );
  }
}

export const chorusEffect = new ChorusEffectImpl();
